import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonCellRendererComponent } from '@lmc-app/custom-table/button-cell-renderer/button-cell-renderer.component';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
  selector: 'app-saha-exception',
  templateUrl: './saha-exception.component.html',
  styleUrls: ['./saha-exception.component.scss']
})
export class SahaExceptionComponent implements AfterViewInit, OnDestroy {
  private readonly _onDestroy = new Subject<void>();
  userData: User | null = null;
	public gridApi_pending: any;
  public gridApi_pending_data: any;
  public gridColumnApi_pending: any;
  public columnDefs_pending = [];
  defaultColDef_pending: any;

  public gridApi_approved: any;
  public gridApi_approved_data: any;
  public gridColumnApi_approved: any;
  public columnDefs_approved = [];
  defaultColDef_approved: any;

  constructor(
    private apiService: LegacyApiService,
    private router: Router,
    private fb: FormBuilder,
    private store: Store<State>
  ) {
    this.store.select(selectUser)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((user: User | null) => {
        this.userData = user;
      });
  }
  pendingData:any;
  approvedData:any;

  waiveOffManagers:any;
  decision = ['Approve','Reject','Cancel'];
  summaryHeaders = [  'JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

  selectedStatus:string;
  sahaSummary:any;

  async ngAfterViewInit() {
    await this.getWaiveOffManagers();
    this.getSahaExceptions();
    this.getSahaExceptionSummary();
    this.columnDefs_pending = [
      // { headerName: 'row_id', field: 'row_id', hide:true},
      // { headerName: 'applicationId', field: 'applicationId', hide:true},
      { headerName: 'Type', field: 'file_type', filter: "agTextColumnFilter", maxWidth:100},
      { headerName: 'Waive-off', field: 'waive_off_mode', filter: "agTextColumnFilter", maxWidth:120},
      { headerName: 'Application Name', field: 'application_name', filter: "agTextColumnFilter" },
      { headerName: 'Amount', field: 'requested_amount', filter: "agNumberColumnFilter", maxWidth:100 },
      { headerName: 'Reason', field: 'requested_reason', filter: "agTextColumnFilter"},
      { headerName: 'Requested By', field: 'requested_agent_name', filter: "agTextColumnFilter" },
      { headerName: 'Date', field: 'requested_date', filter: 'agDateColumnFilter' },
      { headerName: 'Status', field: 'approval_status', filter: 'agTextColumnFilter', maxWidth:100,
        editable: true,
				cellEditor: 'agSelectCellEditor',
				cellEditorParams: {
					values: this.decision
				}
      },
      { headerName: 'Comment', field: 'rejectedReason', filter: "agTextColumnFilter",
        editable: true,
        cellEditor: 'agTextCellEditor',
        cellEditorParams: {
            maxLength: 5000
        },
      },
      { headerName: 'Approved By', field: 'approvedBy', filter: "agTextColumnFilter", maxWidth:150,
        editable: true,
				cellEditor: 'agSelectCellEditor',
				cellEditorParams: {
					values: this.waiveOffManagers
				}
       },
      { headerName: 'Submit', field: 'submit', maxWidth:100,
              cellRenderer: ButtonCellRendererComponent,
              cellRendererParams: {
                label: 'Submit',
                matIconLabel: 'send',
                clicked: (params: any) => {
                  this.approveSahaException(params);
                },
              } },
    ];
    this.defaultColDef_pending = {
      resizable: true
    };

    this.columnDefs_approved = [
      { headerName: 'Cancel', field: 'cancel', maxWidth:100,
        cellRenderer: ButtonCellRendererComponent,
        cellRendererParams: {
          label: 'Cancel',
          matIconLabel: 'cancel',
          clicked: (params: any) => {
            this.cancelApprovedFile(params);
            console.log(params)
          },
        }
      },
      { headerName: 'Comment', field: 'rejectedReason', filter: "agTextColumnFilter",
        editable: true,
        cellEditor: 'agTextCellEditor',
        cellEditorParams: {
            maxLength: 5000
        },
      },
      { headerName: 'Resend', field: 'submit', maxWidth:100,
        cellRenderer: ButtonCellRendererComponent,
        cellRendererParams: {
          label: 'Email',
          matIconLabel: 'email',
          clicked: (params: any) => {
            this.resendWaiveOffLink(params);
          },
        }
      },
      { headerName: 'Funded', field: 'isFunded', filter: 'agTextColumnFilter', maxWidth:100 },
      { headerName: 'Type', field: 'file_type', filter: "agTextColumnFilter", maxWidth:100},
      { headerName: 'Waive-off', field: 'waive_off_mode', filter: "agTextColumnFilter", maxWidth:120},
      { headerName: 'Application Name', field: 'application_name', filter: "agTextColumnFilter" },
      { headerName: 'Amount', field: 'requested_amount', filter: "agNumberColumnFilter", maxWidth:100 },
      { headerName: 'Reason', field: 'requested_reason', filter: "agTextColumnFilter"},
      { headerName: 'Requested By', field: 'requested_agent_name', filter: "agTextColumnFilter" },
      { headerName: 'Date', field: 'requested_date', filter: 'agDateColumnFilter' },
      { headerName: 'Status', field: 'approval_status', maxWidth:100},
      { headerName: 'Approved By', field: 'approved_by', filter: "agTextColumnFilter", maxWidth:150},
      { headerName: 'System Approved By', field: 'system_approved_by', filter: "agTextColumnFilter", maxWidth:150},
      { headerName: 'Approved Date', field: 'approved_date', filter: 'agDateColumnFilter' },
      // { headerName: 'Funded Amount', field: 'original_note_amount', filter: "agNumberColumnFilter", maxWidth:100 },
      // { headerName: 'Funded Date', field: 'funded_date', filter: 'agDateColumnFilter' },
    ];
    this.defaultColDef_approved = {
      resizable: true
    };
  }

  onGridReady(params: any): void {
    this.gridApi_pending = params.api;
    this.gridColumnApi_pending = params.columnApi;
    this.gridApi_pending?.setRowData(this.pendingData);
    this.gridApi_pending_data = this.pendingData;
  }

  onGridReadyApproved(params:any):void{
    this.gridApi_approved = params.api;
    this.gridColumnApi_approved = params.columnApi;
    this.gridApi_approved?.setRowData(this.approvedData);
    this.gridApi_approved_data = this.approvedData;
  }

  getSahaExceptionSummary(){
    this.apiService.getSahaExceptionSummary().subscribe((res:any)=>{
      this.sahaSummary = res;
    })
  }

  getSahaExceptions(){
      this.apiService.getSahaExceptions().subscribe( (res:any)=>{
      this.pendingData = res?.pending;
      this.approvedData = res?.approved;
      this.gridApi_pending?.setRowData(this.pendingData);
      this.gridApi_pending_data = this.pendingData;
      this.gridApi_approved?.setRowData(this.approvedData);
      this.gridApi_approved_data = this.approvedData;
    })
  }

  /**
   * Pass false on updateSahaException
   */
  approveSahaException(params:any){
    const data = {
      approvalData: params ,
      userData: this.userData
    };

    if(data?.approvalData?.approval_status === 'Pending'){
      alert("Please select the Status.")
    }else if(typeof data?.approvalData?.approvedBy === 'undefined'){
      alert("Please select the Approved by.")
    }else if((data?.approvalData?.approval_status === 'Reject' || data?.approvalData?.approval_status === 'Cancel') && typeof data?.approvalData?.rejectedReason === 'undefined'){
      alert("Please enter the comment for Cancellation/Rejection.")
    }else{
      this.apiService.updateSahaException(false,data).subscribe(res=>{
        this.getSahaExceptions();
        this.getSahaExceptionSummary();
      })
    }
  }

  resendWaiveOffLink(params:any){
    if(confirm("Do you want to resend the waive off calculator link?") == true){
      const data = {
        approvalData: params ,
        userData: this.userData
      };
      this.apiService.resendWaiveOffLink(data).subscribe(res=>{
        console.log(res,"Resend link______")
      })
    }
  }

  cancelApprovedFile(params:any){
    if( params?.isFunded === 'Yes'){
      alert("File is funded.");
    }else if(typeof params?.rejectedReason === 'undefined'){
      alert("Please type the cancellation comment.");
    }else{
      params.approval_status = 'Cancel';
      const data = {
        approvalData: params ,
        userData: this.userData
      };
      this.apiService.updateSahaException(false,data).subscribe(res=>{
        this.getSahaExceptions();
        this.getSahaExceptionSummary();
      })
    }
  }

  getWaiveOffManagers() {
		return new Promise((resolve, reject) => {
			this.apiService.getcalculatedNewLoanAmount().subscribe((res: any) => {
        this.waiveOffManagers = res?.waive_off_managers.split(',');
				resolve(this.waiveOffManagers);
			})
		})
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
